/** Returns the embedding page’s address as a URL, using the frame’s src for a srcdoc preview when set. */
export function embedLocation(view = window) {
  const source = String(view.location) === "about:srcdoc" ? view.frameElement?.getAttribute("src") : undefined;
  return new URL(source || view.location.href, view.document?.baseURI);
}
